import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class CoinConfigService {

    constructor(private http: HttpRequestService) {
    }

    getPairs() : Observable<any[]>{
        return this.http.get(`coinconfig/pairs`)
            .map(res => {
                return res.json()
            });
    }

    gets(parameters:any) {
        return this.http.get(`coinconfig/coins`, parameters)
            .map(res => {
                return res.json();
            })
    }

    get(coinId) {
        return this.http.get(`coinconfig/coin?id=${coinId}`)
            .map(res => {
                return res.json();
            })
    }

    active(model: any) {
        return this.http.put(`coinconfig/active`,
            model).map(res => {
                return res.json();
            });
    }

    edit(model: any) {
        return this.http.put(`coinconfig`,
            model).map(res => {
                return res.json();
            });
    }

    getMarkets() : Observable<any[]>{
        return this.http.get(`coinconfig/markets`)
            .map(res => {
                return res.json()
            });
    }

    getLineBotAccounts() : Observable<any[]>{
        return this.http.get(`coinconfig/pairs`)
            .map(res => {
                return res.json()
            });
    }

    setBot(model: any) {
        return this.http.put(`coinconfig/setBot`, model)
            .map(res => {
                return res.json();
            });
    }

    setBotUserExceptCoin(model: any) {
        return this.http.put(`setBotUserExceptCoin`, model)
            .map(res => {
                return res.json();
            });
    }

    activeCoinTemp(model: any) {
        return this.http.post(`activeCoinTemp`, model)
            .map(res => {
                return res.json();
            });
    }
}




// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/coinconfig.service.ts